'use strict';

ebAccountDropdown.$inject = [];

function ebAccountDropdown() {
    return {
        restrict: 'E',
        templateUrl: require('./ebAccountDropdown.html'),
        scope: {
            plural: '@',
            singular: '@',
            labelProp: '@',
            manager: '='
        }
    };
}

module.exports = ebAccountDropdown;



//////////////////
// WEBPACK FOOTER
// ./source/angular/components/admin/directives/ebAccountDropdownDirective.js
// module id = 34
// module chunks = 0